import Facebook from './facebook';
import Invite from './invite';
import Methods from './methods';
import VIP from './vip';

export default {
    Facebook,
    Invite,
    Methods,
    VIP
}